import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider, useAuth } from "@/store/AuthContext";
import { PlayerProvider } from "@/store/PlayerContext";

import NavBar from "@/components/NavBar";
import StickyPlayer from "@/components/StickyPlayer";

import Marketplace from "@/pages/Marketplace";
import BeatDetail from "@/pages/BeatDetail";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function RequireAdmin({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return <div className="p-10 text-[var(--text-dim)]">Loading…</div>;
  }
  if (!user || user.role !== "admin") {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}

function Shell() {
  return (
    <>
      <NavBar />
      <main className="min-h-[60vh]">
        <Routes>
          <Route path="/" element={<Marketplace />} />
          <Route path="/beat/:id" element={<BeatDetail />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <StickyPlayer />
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "#1E1614",
            color: "#F5F2F0",
            border: "1px solid #3A2E2A",
          },
        }}
      />
    </>
  );
}

export default function App() {
  return (
    <div className="grain">
      <BrowserRouter>
        <AuthProvider>
          <PlayerProvider>
            <Shell />
          </PlayerProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
